import { NewOrdersContentContainer } from "components/NewOrders/NewOrders.styles";
import BuildNewOrderLineItems from "components/NewOrders/BuildNewOrderLineItems/BuildNewOrderLineItems";
import NewOrdersHeader from "components/NewOrders/NewOrdersHeader/NewOrdersHeader";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "stores/application.store";
import { BuildOrderHeaderSkeleton } from "pages/OrderPages/BuildOrderPage/buildOrderPage.styles.ts";
import { useParams } from "react-router";
import { getNewOrderTitle } from "utils/string.ts";
import useEmulationParams from "hooks/useEmulationParams.ts";

export interface PageProps {
	isAddOn?: boolean;
	isCustomColor?: boolean;
	isNewQuoteOrder?: boolean;
}

const BuildOrderPage = ({ isAddOn, isCustomColor, isNewQuoteOrder }: PageProps) => {
	const params = useParams();
	const [isLoading, setIsLoading] = useState<boolean>(Boolean(params?.draftId));
	const draftOrder = useSelector((state: RootState) => state.newOrder.draftDetails?.draftOrder);

	const [isLowesUser, setIsLowesUser] = useState<boolean>(false);
	const [isInternalDesigner, setIsInternalDesigner] = useState<boolean>(false);

	const handleSetIsLoading = useCallback((value: boolean) => {
		setIsLoading(value);
	}, []);

	const handleSetIsLowesUser = useCallback((value: boolean) => {
		setIsLowesUser(value);
	}, []);

	const handleSetIsInternalDesigner = useCallback((value: boolean) => {
		setIsInternalDesigner(value);
	}, []);

	useEmulationParams();

	return (
		<div>
			{isLoading ? (
				<BuildOrderHeaderSkeleton
					title={getNewOrderTitle(isAddOn ?? false, isCustomColor ?? false, isLowesUser, isInternalDesigner)}
					data-testid="build-order-loading-skeleton"
				/>
			) : (
				<NewOrdersHeader
					draftOrder={draftOrder}
					isAddOn={isAddOn}
					handleSetIsLowesUser={handleSetIsLowesUser}
					handleSetIsInternalDesigner={handleSetIsInternalDesigner}
				/>
			)}

			<NewOrdersContentContainer>
				<BuildNewOrderLineItems
					handleSetIsLoading={handleSetIsLoading}
					draftOrder={draftOrder}
					isAddOn={isAddOn}
				/>
			</NewOrdersContentContainer>
		</div>
	);
};

export default BuildOrderPage;
